import { storeNavigation } from '@/navigation/store';
import { adminNavigationData } from '@/navigation/admin';
import { customerNavigationData } from '@/navigation/customer';

export default {
  store: storeNavigation,
  admin: adminNavigationData,
  customer: customerNavigationData,
}
